import { render } from "./Privileges.vue?vue&type=template&id=0a567592&scoped=true&ts=true"
import script from "./Privileges.vue?vue&type=script&lang=ts"
export * from "./Privileges.vue?vue&type=script&lang=ts"

import "./Privileges.vue?vue&type=style&index=0&id=0a567592&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a567592"]])

export default __exports__